import React from 'react';
import { Link } from 'react-router-dom';

function Terms() {
  return (
    <div className="min-h-screen bg-[#0a0e27] py-12 px-4">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <Link to="/" className="inline-block mb-4">
            <img src="/logo.png" alt="Logo" className="h-14 w-14 mx-auto" />
          </Link>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-white">Legal & Policies</h1>
          <p className="text-white/40 mt-2 text-sm">Sports Predictions & Tips</p>
        </div>

        {/* Content Card */}
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl border border-white/10 p-6 sm:p-10 space-y-10">

          {/* ===== TERMS OF SERVICE ===== */}
          <section data-testid="terms-section">
            <h2 className="text-xl font-extrabold text-white flex items-center gap-3 mb-5">
              <span className="w-8 h-8 bg-emerald-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 text-emerald-400" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" /></svg>
              </span>
              TERMS OF SERVICE
            </h2>
            <p className="text-white/50 text-sm mb-4">
              <strong className="text-white/70">Sports Predictions & Tips – Terms of Service</strong><br />
              Effective Date: March 1, 2026
            </p>

            <div className="space-y-4 text-white/60 text-sm leading-relaxed">
              <p>
                Sports Predictions & Tips provides sports analysis, opinions and predictions for informational and entertainment purposes only.
              </p>
              <p>
                We are not a sportsbook, casino, betting exchange or gambling operator. We do not accept bets, process wagers or handle gambling funds.
              </p>
              <p>
                All picks and predictions are opinions only. There is no guarantee of winnings or profits. Users are responsible for their own decisions.
              </p>
              <p>
                Users must be at least 18 years old, or 21 where required by applicable law.
              </p>
              <p>
                Subscriptions may automatically renew unless canceled before renewal.
              </p>
            </div>
          </section>

          <div className="border-b border-white/10"></div>

          {/* ===== PRIVACY POLICY ===== */}
          <section data-testid="privacy-section">
            <h2 id="privacy" className="text-xl font-extrabold text-white flex items-center gap-3 mb-5">
              <span className="w-8 h-8 bg-blue-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 text-blue-400" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" /></svg>
              </span>
              PRIVACY POLICY
            </h2>
            <p className="text-white/50 text-sm mb-4">
              <strong className="text-white/70">Sports Predictions & Tips – Privacy Policy</strong><br />
              Effective Date: March 1, 2026
            </p>

            <div className="space-y-4 text-white/60 text-sm leading-relaxed">
              <div>
                <p className="text-white/70 font-bold mb-2">Information We May Collect</p>
                <p className="mb-2">The application may collect information users provide through their account/profile, including:</p>
                <ul className="list-disc list-inside space-y-1 ml-2">
                  <li>Name</li>
                  <li>Email address</li>
                  <li>Phone number</li>
                  <li>Birthday</li>
                  <li>City/address information</li>
                  <li>Profile photo</li>
                  <li>Subscription/account information</li>
                </ul>
              </div>

              <div>
                <p className="text-white/70 font-bold mb-2">How We Use This Information</p>
                <ul className="list-disc list-inside space-y-1 ml-2">
                  <li>Provide account access</li>
                  <li>Maintain user profiles</li>
                  <li>Manage subscriptions</li>
                  <li>Provide customer support and account verification when necessary</li>
                  <li>Communicate service updates</li>
                  <li>Improve the service</li>
                </ul>
              </div>

              <p>We do not sell users' personal information.</p>

              <p>
                Contact for privacy/support:{' '}
                <a href="mailto:support@sportspredictionstips.com" className="text-emerald-400 hover:text-emerald-300 font-bold">
                  support@sportspredictionstips.com
                </a>
              </p>
            </div>
          </section>

          <div className="border-b border-white/10"></div>

          {/* ===== REFUND POLICY ===== */}
          <section data-testid="refund-section">
            <h2 className="text-xl font-extrabold text-white flex items-center gap-3 mb-5">
              <span className="w-8 h-8 bg-amber-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 text-amber-400" fill="currentColor" viewBox="0 0 20 20"><path d="M4 4a2 2 0 00-2 2v4a2 2 0 002 2V6h10a2 2 0 00-2-2H4zm2 6a2 2 0 012-2h8a2 2 0 012 2v4a2 2 0 01-2 2H8a2 2 0 01-2-2v-4zm6 4a2 2 0 100-4 2 2 0 000 4z" /></svg>
              </span>
              REFUND POLICY
            </h2>

            <div className="space-y-3 text-white/60 text-sm leading-relaxed">
              <p>Subscriptions can be canceled to prevent future billing.</p>
              <p>Refunds for partially used subscription periods are not guaranteed unless required by applicable law.</p>
              <p>Duplicate or incorrect charges can be reviewed by support.</p>
              <p>
                Contact:{' '}
                <a href="mailto:support@sportspredictionstips.com" className="text-emerald-400 hover:text-emerald-300 font-bold">
                  support@sportspredictionstips.com
                </a>
              </p>
            </div>
          </section>

          <div className="border-b border-white/10"></div>

          {/* ===== LEGAL DISCLAIMER ===== */}
          <section data-testid="disclaimer-section">
            <h2 className="text-xl font-extrabold text-white flex items-center gap-3 mb-5">
              <span className="w-8 h-8 bg-red-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 text-red-400" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" /></svg>
              </span>
              LEGAL DISCLAIMER
            </h2>

            <div className="bg-amber-500/5 border border-amber-500/20 rounded-xl p-5 space-y-3 text-white/60 text-sm leading-relaxed">
              <p>
                Sports Predictions & Tips provides sports predictions and analysis for <strong className="text-white/80">informational and entertainment purposes</strong>.
              </p>
              <p>
                We are <strong className="text-white/80">not a gambling platform</strong> and do not accept wagers.
              </p>
              <p>
                There is <strong className="text-white/80">no guarantee of winnings or profits</strong>.
              </p>
              <p>
                Users are responsible for their own betting decisions and should bet responsibly.
              </p>
            </div>
          </section>

          <div className="border-b border-white/10"></div>

          {/* ===== CONTACT & SUPPORT ===== */}
          <section data-testid="contact-section">
            <h2 className="text-xl font-extrabold text-white flex items-center gap-3 mb-5">
              <span className="w-8 h-8 bg-cyan-500/20 rounded-lg flex items-center justify-center flex-shrink-0">
                <svg className="w-4 h-4 text-cyan-400" fill="currentColor" viewBox="0 0 20 20"><path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" /><path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" /></svg>
              </span>
              CONTACT & SUPPORT
            </h2>

            <div className="bg-white/5 rounded-xl p-6 border border-white/10">
              <p className="text-white/60 text-sm mb-4">
                For any questions, support requests, or inquiries, please contact us:
              </p>
              <a
                href="mailto:support@sportspredictionstips.com"
                className="inline-flex items-center gap-3 bg-gradient-to-r from-emerald-500 to-cyan-500 hover:from-emerald-600 hover:to-cyan-600 text-white px-6 py-3 rounded-xl font-bold text-sm transition-all shadow-lg shadow-emerald-500/20"
                data-testid="support-email-link"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
                support@sportspredictionstips.com
              </a>
            </div>
          </section>

        </div>

        {/* Back Button */}
        <div className="text-center mt-8">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-white/50 hover:text-white/80 font-bold text-sm transition-colors"
            data-testid="back-home-link"
          >
            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" /></svg>
            Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Terms;
